import { PrimaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";

import styles from "./AddToBasketButton.module.scss";

type AddToBasketButtonProps = {
  disabled: boolean;
  isSubmitting: boolean;
  handleAddToBasketClick: () => void;
  buttonText?: string;
  ref?: React.Ref<HTMLButtonElement>;
};

export const AddToBasketButton = ({
  disabled,
  handleAddToBasketClick,
  isSubmitting,
  buttonText = "Add to basket",
  ref,
}: AddToBasketButtonProps) => {
  return (
    <PrimaryButton
      // small hack for TS not understanding the ref passed to button
      {...(ref ? { ref } : {})}
      className={styles.button}
      disabled={disabled}
      submitting={isSubmitting}
      onClick={handleAddToBasketClick}
    >
      {buttonText}
    </PrimaryButton>
  );
};
